import { useEffect, useState } from 'react';
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { StatusService } from '../../services/StatusService';

import Toast from "../../helpers/Toast";

import { FormattedMessage } from 'react-intl';
import ButtonComponent from '../../components/ButtonComponent';
import useValidationSchema, { FieldConfig } from "../../components/Validations";
import { RoleStatusPermissionsDTO } from "../../models/Status/RoleStatusPermissionsDTO";
import { RoleDTO } from '../../models/User/RoleDTO';
import { SearchRoleDTO } from '../../models/User/SearchRoleDTO';
import { SelectItemsProps } from '../SearchSelectComponent';
import SelectComponent from '../SelectComponent';
import { Col, Row} from 'reactstrap';
import PageTitle from "../../components/Layout/PageTitle";
import Layout from '../../components/Layout/Layout';

type CreateStatusPermissionProps = {
    baseStatus: string,
    onSuccess: () => void,
    onCancel: () => void,
}

function CreateStatusPermission({baseStatus, onSuccess, onCancel}: CreateStatusPermissionProps) {
    const statusService = new StatusService();
    const intl = useIntl();

    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState<SelectItemsProps[]>([]);
    const [nameRole, setNameRole] = useState<RoleDTO>({} as RoleDTO);

    const fields: FieldConfig[] = [
        ["roleId", "string", "Screens.Status.Create.Permission.Role"],
    ]

    const schemaClientValidation = useValidationSchema(fields);

    const GetAllRoles = async () => {
        const response = await statusService.GetAllRoles();
        if (!response.success || !response.obj) {
            Toast.Show("error", response.message);
            return;
        }

        const list: SelectItemsProps[] = response.obj.map((element) => ({
            value: element.name,
            label: element.name,
        }));

        setRoles(list);
    }

    useEffect(() => {
        GetAllRoles();
    }, []);

    const handleCreate  = async () => {
        setLoading(true);

        const searchRole: SearchRoleDTO = { name: nameRole.name };
        const role = await statusService.GetRoleByName(searchRole);

        if (!role.obj) {
            Toast.Show("error", "O perfil é necessário.");
            setLoading(false);
            return;
        }

        const data: RoleStatusPermissionsDTO = {
            roleId: role.obj.id.toString(),
            statusId: Number(baseStatus),
            roleName: nameRole.name,
        };

        const { error } = schemaClientValidation.validate(data);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoading(false);
            return;
        }

        const result = await statusService.CreateStatusPermission(data);

        if (!result.success) {
            Toast.Show("error", "Permissão para esse perfil já existe, não a vamos duplicar.");
            setLoading(false);
            return;
        }

        Toast.Show("success", "Permissão criada com sucesso.");
        setLoading(false);
        onSuccess();
    };

return (
        <>
            <Col>
                <SelectComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px", marginBottom: "25px" }}
                    label={intl.formatMessage({ id: "Screens.Status.Search.Role" })}
                    selectedItemValue={nameRole.name}
                    items={roles}
                    onChange={(t: string) => setNameRole({ ...nameRole!, name: t })}
                />
                <Row>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "25px" }}>
                <ButtonComponent
                    text={intl.formatMessage({ id: "Common.Buttons.Cancel" })}
                    onClick={onCancel}
                    style={{ minHeight: "37px", minWidth: "100px" }}
                />
                <ButtonComponent
                    text={intl.formatMessage({ id: "Screens.Status.Create.Permission" })}
                    onClick={handleCreate}
                    style={{ minHeight: "37px", minWidth: "150px" }}
                    loading={loading}
                />
            </div>
                </Row>
            </Col>
        </>
    );
}

export default CreateStatusPermission;